<template>
  <div class="pt-2">
    <b-badge
      v-for="(badge, index) in badge_collection"
      :key="index"
      pill
      class="float-left font-sm my-1 ml-2"
      >{{ badge }}</b-badge
    >
  </div>
</template>
<script>
export default {
  name: "BadgeBatch",
  props: {
    badge_collection: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
